import { render, staticRenderFns } from "./SecondGraduationSendDocumentForm.vue?vue&type=template&id=3239cb60&scoped=true&"
import script from "./SecondGraduationSendDocumentForm.vue?vue&type=script&lang=ts&"
export * from "./SecondGraduationSendDocumentForm.vue?vue&type=script&lang=ts&"
import style0 from "./SecondGraduationSendDocumentForm.vue?vue&type=style&index=0&id=3239cb60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3239cb60",
  null
  
)

export default component.exports